import { render, staticRenderFns } from "./promo-build.vue?vue&type=template&id=63b2c42c&scoped=true&"
import script from "./promo-build.vue?vue&type=script&lang=js&"
export * from "./promo-build.vue?vue&type=script&lang=js&"
import style0 from "./promo-build.vue?vue&type=style&index=0&id=63b2c42c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2c42c",
  null
  
)

export default component.exports